exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".address-parts-inline div{display:inline-block;margin-right:5px}", ""]);

// exports
